import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../contexts/ConfigContext'
import { IonCol, IonDatetime, IonGrid, IonItem, IonLabel, IonRow, IonSelect, IonSelectOption } from '@ionic/react'
import jsonata from 'jsonata'
import { calcSalePurchase } from '../Graphs/SalesGraph'

// eslint-disable-next-line no-extend-native
Date.prototype.addDay = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

const BalanceSheet = () => {

    const { getSalesAmount, getPurchaseAmount, getStocksValue, getExpenseAmount, 
        getLedgerValues, getStocks, getInvoices, getPurchase } = useContext(ConfigContext);

    const [sales, setsales] = useState(0)
    const [purchase, setpurchase] = useState(0)
    const [date] = useState(new Date());
    const [days, setDays] = useState(365)
    const [fromDate, setFromDate] = useState(date.addDay(-days));
    const [toDate, setToDate] = useState(date);

    const [Stocks, setStocks] = useState([]);
    const [stocksValue, setStocksValue] = useState(0);
    const [expenseAmt, setExpenseAmt] = useState(0);
    const [saleAmt, setSaleAmt] = useState(0);
    const [purchaseAmt, setPurchaseAmt] = useState(0);
    const [ledgerValues, setLedgerValues] = useState({
        payable: 0,
        receivable: 0,
        cashinHand: 0,
        balance: 0,
        credit: 0,
        debit: 0,
    })
    const { payable, receivable, cashinHand } = ledgerValues;

    useEffect(() => {
        Promise.all([getInvoices(), getPurchase()]).then(([invoices, purchase]) => {
            const x = calcSalePurchase(invoices, purchase, fromDate, toDate)
            console.log(x);
            let res = jsonata('$sum($.sale)').evaluate(x);
            let res1 = jsonata('$sum($.purchase)').evaluate(x);
            setsales(res);
            setpurchase(res1)
        })

        getStocks().then(stocks => {
            setStocks(stocks)
        })

        getStocksValue().then(res => {
            setStocksValue(res)
        })
        getExpenseAmount().then(res => {
            setExpenseAmt(res)
        })
        getLedgerValues().then(res => {
            setLedgerValues(res)
        })
        getSalesAmount().then(res => {
            setSaleAmt(res)
        })
        getPurchaseAmount().then(res => {
            setPurchaseAmt(res)
        })

        return () => {
            setsales(0)
            setpurchase(0)
            setStocks([])
            setStocksValue(0);
            setExpenseAmt(0);
            setSaleAmt(0);
            setPurchaseAmt(0);
            setLedgerValues({
                payable: 0,
                receivable: 0,
                cashinHand: 0,
                balance: 0,
                credit: 0,
                debit: 0,
            })
        }
    }, [fromDate, toDate, getExpenseAmount, getInvoices, getLedgerValues, getPurchase, getPurchaseAmount, getSalesAmount, getStocks, getStocksValue]);



    let open = jsonata("$sum(log[type='Opening Stock'].(rate * quantity))").evaluate(Stocks);
    let opening = open ? open : 0;
    let closing = stocksValue;
    let grossProfit = sales + closing - (purchase + opening) ;
    let expenses = expenseAmt;
    let netIncome = grossProfit - expenses;

    let overallIncome = saleAmt + closing - (purchaseAmt + opening  + netIncome +expenses);

    let currLibality = payable;
    let equity = netIncome + opening + overallIncome;
    let libTotal = currLibality + equity;
    let assTotal = cashinHand + receivable + stocksValue;

    const Assets = () => (
        <IonCol>
            <IonItem color='light'>
                <h4>Assets</h4>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Current Assets</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Amount</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Cash in Hand</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{cashinHand}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Bank Accounts</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>0</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Accounts Receivables</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{receivable}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Inventory on Hand</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{stocksValue}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Tax Receivables</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{0}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Total</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel color='primary'>{assTotal}</IonLabel>
                </IonCol>
            </IonItem>
        </IonCol>
    )

    const Liabilities = () => (
        <IonCol>
            <IonItem color='light'>
                <h4>Liabilities</h4>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Equity/Capital</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>Amount</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Opening Balance Equity</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{/** opening stock */ opening}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Retained Earnings</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{/** sum of net income */ overallIncome}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Net Income (Profit)</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{/** from profitloss */ netIncome}</IonLabel>
                </IonCol>
            </IonItem>
            {/* <IonItem>
                <IonCol>
                    <IonLabel >Current Liability</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{currLibality}</IonLabel>
                </IonCol>
            </IonItem> */}
            <IonItem>
                <IonCol>
                    <IonLabel >Accounts Payable</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{payable}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel >Tax Payable</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel>{0}</IonLabel>
                </IonCol>
            </IonItem>
            <IonItem>
                <IonCol>
                    <IonLabel>Total</IonLabel>
                </IonCol>
                <IonCol>
                    <IonLabel color='primary'>{libTotal}</IonLabel>
                </IonCol>
            </IonItem>

        </IonCol>
    )
    return (
        <div>
            <IonGrid container>
                <h3>Balance Sheet</h3>
                <IonItem>
                    <IonCol>
                        <IonSelect interface='popover' value={days} onIonChange={e => {
                            let n = e.target.value;
                            setDays(n)
                            let from = new Date(Date.now() - n * 24 * 60 * 60 * 1000);
                            setFromDate(from);
                            console.log(days, from, toDate);


                        }}>
                            <IonSelectOption value={0}>Today</IonSelectOption>
                            <IonSelectOption value={7}>This week</IonSelectOption>
                            <IonSelectOption value={30}>This month</IonSelectOption>
                            <IonSelectOption value={365}>This year</IonSelectOption>
                        </IonSelect>
                    </IonCol>
                    <IonCol>
                        <IonLabel>From</IonLabel>
                        <IonDatetime id='date' value={fromDate.toUTCString()} onIonChange={e => setFromDate(new Date(e.target.value))} ></IonDatetime>
                    </IonCol>
                    <IonCol>
                        <IonLabel>To</IonLabel>
                        <IonDatetime id='date' value={toDate.toUTCString()} onIonChange={e => setToDate(new Date(e.target.value))} ></IonDatetime>
                    </IonCol>
                </IonItem>
                <IonRow>
                    {Assets()} {Liabilities()}
                </IonRow>
            </IonGrid>



        </div>
    )
}

export default BalanceSheet
